import { FC } from 'react'
import { getAttendanceReasonName } from 'services/Utilities'

import { t } from 'translations'

const AttendanceInfo: FC<{ attendance: MData.Attendance }> = ({ attendance }) => {
  const { _id, arrivalTime, departureTime, reasonId, requestTypeId } = attendance
  switch (requestTypeId) {
    case 1:
      return (
        <small className="d-flex flex-row align-items-baseline text-danger mt-1">
          <i className="fas fa-info-circle mr-2"></i>
          <a data-cy="absence-reason" className="text-link text-danger" href={`/my/attendance/${_id}`}>
            {getAttendanceReasonName(reasonId)}
          </a>
        </small>
      )
    case 2:
      return (
        <small className="d-flex flex-row align-items-baseline text-warning mt-1">
          <i className="fas fa-info-circle mr-2"></i>
          <a data-cy="absence-reason" className="text-link text-warning" href={`/my/attendance/${_id}`}>
            {t('employee.requestType.ARRIVING_AT', { arrivalTime })}
            <br />
            {getAttendanceReasonName(reasonId)}
          </a>
        </small>
      )
    case 3:
      return (
        <small className="d-flex flex-row align-items-baseline text-warning mt-1">
          <i className="fas fa-info-circle mr-2"></i>
          <a data-cy="absence-reason" className="text-link text-warning" href={`/my/attendance/${_id}`}>
            {t('employee.requestType.LEAVING_AT', { departureTime })}
            <br />
            {getAttendanceReasonName(reasonId)}
          </a>
        </small>
      )
    default:
      break
  }

  return null
}

export { AttendanceInfo }
